import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
export default function () {
  var retryTimes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      stopRetryCheck = _ref.stopRetryCheck,
      retryHost = _ref.retryHost;

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      var _retryTimes, _retryHost, _stopRetryCheck;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _retryTimes = retryTimes;
              _retryHost = retryHost || this.request.hostname;

              _stopRetryCheck = stopRetryCheck || function () {
                return 0;
              };

            case 3:
              if (!(_retryTimes >= 0)) {
                _context.next = 18;
                break;
              }

              _retryTimes--;
              _context.prev = 5;
              _context.next = 8;
              return next();

            case 8:
              return _context.abrupt("return");

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);

              if (!(_retryTimes < 0 || _stopRetryCheck(_context.t0))) {
                _context.next = 15;
                break;
              }

              throw _context.t0;

            case 15:
              this.request.hostname = _retryHost;
              _context.next = 3;
              break;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 11]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}